"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createEventOrSeasonFee(
    $orgId: String
    $eventId: String
    $seasonId: String
    $fee: FeeInput!
  ) {
    createEventOrSeasonFee(
      orgId: $orgId
      eventId: $eventId
      seasonId: $seasonId
      fee: $fee
    ) {
      _id
      name
      eventId
      seasonId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      paymentMethods
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
      __typename
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=createEventOrSeasonFee.mutation.js.map